import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DxFileManagerComponent, DxGalleryComponent } from 'devextreme-angular';
import CustomFileSystemProvider from 'devextreme/file_management/custom_provider';
import FileSystemItem from 'devextreme/file_management/file_system_item';
import { GdriveService } from '../services/gdrive.service';
import { GlobalService } from '../services/global.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {


  provider: any = {};
  preview:any =  { title: "", data: this.safe.bypassSecurityTrustResourceUrl(""), mime: "", visible:false};
  uploadData: File = null;
  deleteFile: FileItem[] = [];
  updatedData: FileItem[] = [];
  selectedFile: FileItem[] = [];
  enableInput:boolean = false;
  data:any = {apps:"",path:""};

  @ViewChild('fm') fm: DxFileManagerComponent;
  @ViewChild('gallery') gallery:DxGalleryComponent;

  constructor(private auth:AuthService,private global: GlobalService, public safe: DomSanitizer, private gdrive: GdriveService, private route: ActivatedRoute) {
    this.gdriveUploadItem = this.gdriveUploadItem.bind(this);
    this.gdriveGetItem = this.gdriveGetItem.bind(this);
    this.gdriveDeleteItem = this.gdriveDeleteItem.bind(this);
    this.gdriveDownloadItem = this.gdriveDownloadItem.bind(this);

    this.route.paramMap.subscribe((res) => {
      this.data.apps = res.get("apps");
      this.data.path = res.get("path");
      if(this.data.path!=""){
        this.data.path = this.data.path.split("%2F").join("/");
      }
    });
  }

  ngOnInit() {
    if(this.data.apps!=""&&this.data.path!=""&&this.auth.getCookie('token')!=undefined){
      this.loadFile(this.data.path);
    }
  }

  loadFile(path: string) {
    this.global.message = "Loading, please wait...";
    this.global.blockUI = true;
    this.createProvider();
    this.clearUpload();
    this.gdrive.getListFile(this.data.apps,path).then((res: FileItem[]) => {
      this.selectedFile = res;
      this.fm.instance.refresh();
      this.global.blockUI = false;
    });
  }

  createProvider(){
    this.clearUpload();
    let provider: CustomFileSystemProvider = new CustomFileSystemProvider({
      isDirectoryExpr: "isFolder",
      sizeExpr: "size",
      keyExpr: "id",
      dateModifiedExpr: "dateModified",
      nameExpr: "name",
      thumbnailExpr: "thumbnailLink",
      getItems: this.gdriveGetItem,
      deleteItem: this.gdriveDeleteItem,
      downloadItems: this.gdriveDownloadItem,
      uploadFileChunk: this.gdriveUploadItem
    });

    this.provider = provider;
    if (this.fm.instance) {
      this.fm.instance.refresh();
    }
  }

  gdriveGetItem(item: FileSystemItem): Promise<any[]> {
    return new Promise<any[]>((resolve => {
      resolve(this.selectedFile);
    }));
  }

  gdriveDeleteItem(item: FileSystemItem) {
    let file: FileItem = item.dataItem;
    let index = this.selectedFile.findIndex(x => x.id == file.id);
    this.selectedFile.splice(index, 1);
    if (file.id != file.name) {
      this.deleteFile.push(file);
    }
  }

  gdriveUploadItem(file: File) {
    return new Promise<any[]>(((resolve) => {
      let index = this.selectedFile.findIndex(x => x.name == file.name);
      let insert: boolean = true;

      //Check Duplicate Input For Same File
      if (this.uploadData != null) {
        insert = this.uploadData.name != file.name || this.uploadData.lastModified != file.lastModified;
      } else {
        this.uploadData = file;
      }
      if (insert) {
        let newFile: FileItem = new FileItem();
        newFile.id = file.name;
        newFile.isFolder = false;
        newFile.mimeType = file.type;
        newFile.name = file.name;
        newFile.size = file.size;
        let fileReader = new FileReader();
        fileReader.onload = (e) => {
          newFile.src = fileReader.result.toString();
          if (index >= 0) {
            this.deleteFile.push(this.selectedFile[index]);
            this.selectedFile.splice(index, 1);
          }
          this.selectedFile.push(newFile);
          this.uploadData = null;
          resolve([newFile]);
        };
        fileReader.readAsDataURL(file);
        fileReader.onerror = (error) => {
          console.log('Error: ', error);
        };
      } else {
        resolve([]);
      }
    }));
  }

  gdriveDownloadItem(item: FileSystemItem[]) {
    item.forEach((data: FileSystemItem) => {
      let d = data.dataItem;
      let mimeType = d.mimeType;
      let fileName = d.name;
      let base64 = "";
      let index = this.selectedFile.findIndex(x => x.id == d.id && x.src != "");
      if (index >= 0) {
        base64 = this.selectedFile[index].src;
        this.generateDownload(fileName, mimeType, base64);
      } else {
        this.gdrive.getBase64File(this.data.apps, d.id).then(res => {
          base64 = res;
          this.generateDownload(fileName, mimeType, base64);
        });
      }
    });
  }

  generateDownload(fileName, mimeType, base64) {
    var a = document.createElement("a");
    let src = base64.toString().indexOf("data") >= 0 ? base64 : 'data:' + mimeType + ';base64,' + base64;
    a.href = src;
    a.download = fileName;
    a.click();
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.safe.bypassSecurityTrustUrl(imageUrl);
  }

  clearUpload() {
    this.selectedFile = [];
    this.updatedData = [];
    this.deleteFile = [];
    this.uploadData = null;
  }

  displayDataPopup(e) {
    let index = this.selectedFile.findIndex(x => x.id == e.file.dataItem.id);
    this.preview.visible = true;
    this.gallery.instance.goToItem(index,false);
  }

  selectionChanged(e){
    let file = e.addedItems[0];
    this.preview.title = file.name;
    this.global.message = "Loading, please wait...";
    this.global.blockUI = true;

    if (file.src === "") {
      let index = this.selectedFile.findIndex(x => x.id == file.id);
      if (file.src == "") {
        this.preview.mime = file.mimeType;
        this.gdrive.getBase64File(this.data.apps, file.id).then(res => {
          let src = res.toString().substring(0, 5) == "data:" ? res : 'data:' + this.preview.mime + ';base64,' + res;
          this.selectedFile[index].src = src;
          this.global.blockUI = false;
        }).catch(() => { this.global.blockUI = false; });
      } else {
        this.global.blockUI = false;
      }
    } else {
      this.global.blockUI = false;
    }
  }

}

export class FileItem {
  name: string;
  isFolder: boolean;
  size?: number;
  id: string;
  mimeType: string;
  src: string;
  dateModified: number;
  thumbnailLink: string;
}
